import styles from './Footer.module.css';

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.left}>
          Infundra &mdash; Infrastructure-Led Venture Platform
        </div>
        <div className={styles.right}>
          Infundra,LLC &copy; 2026
        </div>
      </div>
    </footer>
  );
}
